/**
 * Función auxiliar para agregar tooltips con delay personalizado
 * @param marker - El marcador de Leaflet
 * @param content - Contenido del tooltip
 * @param options - Opciones del tooltip
 * @param delay - Delay en milisegundos (por defecto 500ms)
 */
export const addTooltipWithDelay = ({
  marker,
  content,
  options = {},
  delay = 300, // Delay por defecto de 300ms
}) => {
  let tooltipTimeout: any;
  let isMouseOver = false;

  // Configurar opciones por defecto si no se proporcionan
  const defaultOptions = {
    direction: 'right',
    className: 'custom-mat-tooltip',
    offset: [14, -18],
    opacity: 1,
    permanent: false,
    ...options,
  };

  // Bind el tooltip pero sin mostrarlo automáticamente
  marker.bindTooltip(content, { ...defaultOptions, permanent: false });

  // Remover el comportamiento automático del tooltip
  marker.off('mouseover');
  marker.off('mouseout');
  marker.off('click');

  // Agregar eventos personalizados con delay
  marker.on('mouseover', () => {
    isMouseOver = true;
    // Limpiar timeout anterior si existe
    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
    }

    tooltipTimeout = setTimeout(() => {
      // Solo mostrar si el mouse sigue sobre el elemento
      if (isMouseOver) {
        marker.openTooltip();
      }
    }, delay);
  });

  marker.on('mouseout', () => {
    isMouseOver = false;
    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
      tooltipTimeout = null;
    }
    marker.closeTooltip();
  });

  // Cerrar tooltip en click para evitar que se quede abierto
  marker.on('click', () => {
    marker.closeTooltip();
  });
};
